import React from 'react'
import { connect } from 'react-redux'
import { acceptTerms } from 'ducks/registration'
import Form from 'antd/lib/form'
import Button from 'antd/lib/button'
import Input from 'antd/lib/input'

import l8n from 'l8n'
import {siteUrl} from 'scripts/siteUrl'

import { AuthPolicy } from 'components/CleanComponents/AuthPolicy/index'

const mapDispatchToProps = dispatch => ({
  acceptTerms: (accept) => dispatch(acceptTerms(accept)),
})

@connect(null, mapDispatchToProps)
@Form.create()
class LoginForm extends React.Component {
  onSubmit = event => {
    event.preventDefault()
    this.props.acceptTerms(true)
  }

  render() {
    return (
      <Form className="auth-form" onSubmit={this.onSubmit}>
        <Form.Item>
          <Input.TextArea
            readOnly
            rows={12}
            value={l8n.p_conditions}
            style={{minHeight: 200}}
          />
        </Form.Item>
        {l8n.locale === 'ru' ?
          <Form.Item>
            <a
              href={`${siteUrl()}/files/affiliate_agreement.pdf`}
              type="application/pdf"
              target="_blank"
            >
              {l8n.p_print_version}
            </a>
          </Form.Item>
          :
          ''}
        <div className="form-actions">
          <Button
            type="primary"
            htmlType="submit"
            className="auth-form-button"
          >
            {l8n.p_accept_terms}
          </Button>
        </div>
        <AuthPolicy/>
      </Form>
    )
  }
}

export default LoginForm


// WEBPACK FOOTER //
// ./src/components/CustomComponents/Form/RegistrationForm/TermsForm/index.js